import { supabase } from "./supabase";
import type { SetUpdate } from "./setFieldWrite";

/** The live half of `setFieldWrite.SetUpdate`: `update coach_workout_sets set <one column> where id in (…)`, as the coach. */
export const updateSets: SetUpdate = (payload, ids) => supabase.from("coach_workout_sets").update(payload).in("id", [...ids]);
